<div class="userchat">
  <!-- clase box -->
  <div class="subbasicbox chat headinguser">
    <div class="boximage">
      <a [routerLink]="otherUserId ? ['/dashboard/profile', otherUserId] : []">
        <img
          *ngIf="selectedChatUser?.avatar; else defaultheadavatar"
          src="{{ selectedChatUser?.avatar }}"
          alt="{{ getUserFullName(selectedChatUser, otherUserId) | titlecase }}"
        />
        <ng-template #defaultheadavatar
          ><img src="assets/img/defaultavatar.jpg" alt=""
        /></ng-template>

        <!--<div class="status"></div>-->
      </a>
    </div>
    <div class="boxtitles">
      <h4>
        {{ getUserFullName(selectedChatUser, otherUserId) | titlecase }}
      </h4>
      <!-- <h3 >{{chatUsers[otherUserId]?.user}}</h3> -->
    </div>
    <div class="botones">
      <div class="boxchatvideocall">
        <a
          href="https://access.colegia.education/webapp3/#/?conference={{
            getUsername(selectedChatUser) || otherUserId
          }}&name={{ getUserFullName(mainChatUser, mainUserId) | titlecase
          }}&role=guest&callType=video&join=1"
          target="_blank"
        >
          <img src="assets/img/videocall.svg" alt="" />
        </a>
      </div>
      <div
        class="boxchatvideocall"
        *ngIf="
          chatUser && getUserRole(chatUser) != 'student' &&
          getUserRole(chatUser) != 'student' &&
          selectedChatUser?.padres?.length > 0
        "
      >
        <a routerLink="/dashboard/padres/{{ otherUserId }}">
          <img title="{{'dashboard.padres.titulo'| translate}}" src="assets/img/padreslogoazul.png" alt="" />
        </a>
      </div>
    </div>

    <div class="boxdata"></div>

    <div class="boxvideocall"></div>
  </div>
  <!--/clase box -->

  <section class="basicbox chatmessages">
    <div class="messages" id="themessagesbox" [scrollTop]="scrolltobottom()">
      <ng-container *ngFor="let messages of chatGroups[urlUid]">
        <!-- message -->
        <div class="message">
          <div class="avatar">
            <img
              *ngIf="
                chatUsers[messages?.payload.doc.data().sender_id]?.avatar;
                else defaultavatar
              "
              src="{{ chatUsers[messages?.payload.doc.data().sender_id]?.avatar }}"
              alt="{{
                getUserFullName(chatUsers[messages?.payload.doc.data().sender_id])
              }}"
            />
            <ng-template #defaultavatar
              ><img src="assets/img/defaultavatar.jpg" alt=""
            /></ng-template>

            <!--<div class="status"></div>-->
          </div>
          <div class="messagedata">
            <div class="name">
              {{ getUserFullName(chatUsers[messages?.payload.doc.data().sender_id]) }}
            </div>
            <div class="date">
              {{
                messages?.payload.doc.data().created_at
                  | date : "dd/MM/y - HH:mm"
              }}h
            </div>
            <div class="themessage">
              <p>{{ messages?.payload.doc.data().content }}</p>
            </div>
          </div>
        </div>
        <!-- /message -->
      </ng-container>
    </div>
    <div class="sendbox">
      <input
        class="messagebox"
        type="text"
        placeholder="{{ 'dashboard.mensajes.escribirmensaje' | translate }}"
        [(ngModel)]="chatMessage"
        (keyup.enter)="sendmessage()"
      />
      <input
        class="sendmessage"
        type="submit"
        value="{{ 'dashboard.mensajes.enviarmensaje' | translate }}"
        (click)="sendmessage()"
      />
    </div>
  </section>
</div>
